@if (authService.hasPermission(Permission.ProductsLabelData)) {
  @if (buttonStyle === 'icon') {
    <button
      mat-icon-button
      [matTooltip]="tooltip"
      [disabled]="!assetId"
      (click)="onExtract(); $event.stopPropagation()">
      @if (extracting) {
        <mat-spinner diameter="18"></mat-spinner>
      }
      @if (!extracting) {
        <mat-icon>autorenew</mat-icon>
      }
    </button>
  }
  @if (buttonStyle === 'raised') {
    <button
      mat-raised-button
      color="buttonSuccess"
      [disabled]="!assetId"
      (click)="onExtract(); $event.stopPropagation()">
      Parse Label
    </button>
  }
}
